import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDialPadErrorIcon = lazy(() => import('./svg-components/dial-pad-error-icon'));

const DialPadErrorIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDialPadErrorIcon {...rest} />
  </Suspense>
);

export default DialPadErrorIcon;
